<template>
  <div class="row flex">
    <div
      class="col col-xxs-6 col-xs-6 col-sm-6 col-md-3"
      :style="{ order: article.priority }"
      :key="index"
      v-for="(article, index) in articles"
    >
      <a v-on:click="clickLink(article.id,article.priority)">
        <div class="thumbnail new-thumbnail">
          <img v-bind:src="app_root + '/assets/article' + article.id + '/images/i7_small.jpg'" alt="..." class="lazyload"/>
          <div class="caption">
            <h3 class="thum_title items" ref="items">
              <LabelFunMessage :fcontId="article.id.toString()" msgkey="1" />
            </h3>
            <p class="des_funcontents">
              <LabelFunMessage :fcontId="article.id.toString()" msgkey="2" />
            </p>
          </div>
          <img v-if="article.isNew" :src="app_root + '/assets/common/img/new_label.svg'" class="new_label" />
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import LabelFunMessage from "./LabelFunMessage";
import { mapState } from 'vuex';

export default {
  name: "ArticleTiles",
  props: {
    articles: Array
  },
  components: {
    LabelFunMessage
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    ...mapState(['setupnavi', 'languageChangeCount', 'lg2']),
  },
  methods: {
    clickLink: function (id, priority) {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "top_articles",
        "custom_parameter2": `${id}`,
        "custom_parameter3": `${priority}`
      })

      this.$router.push({ 
        path: '/' + this.lg2 + '/articles/' + id,
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }  
       })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

.flex::before, .row::after{
  display: none;
}

.flex .col {
  padding-bottom: 20px;
}

.thumbnail {
  height: 100%;
  margin-bottom: 0px;
}

@media (max-width: 767px) {
  .flex .col {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>